import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class AdShareByEmailUserUseCase extends UseCase {
  constructor({config, adShareByEmailUserService, saveAdShareByEmailHitUserService}) {
    super()
    this._config = config
    this._adShareByEmailUserService = adShareByEmailUserService
    this._saveAdShareByEmailHitUserService = saveAdShareByEmailHitUserService
  }
  /**
   * @method
   * @return {Promise}
   */

  @inlineError
  async execute({adId, contractId, email}) {
    const [saveHitError] = await this._saveAdShareByEmailHitUserService.execute({adId})
    if (saveHitError) return Promise.reject(saveHitError)

    const [adShareByEmailError] = await this._adShareByEmailUserService.execute({
      adId,
      contractId,
      email
    })

    if (adShareByEmailError) return Promise.reject(adShareByEmailError)
    return Promise.resolve(true)
  }
}
